export default "__VITE_ASSET__CX9llZCK__";